import { createFileRoute } from '@tanstack/react-router';

import { LegalDocumentPage } from '@/features/legal/LegalDocumentPage';

function TermsOfServicePage() {
  return <LegalDocumentPage type="TERMS_OF_SERVICE" />;
}

export const Route = createFileRoute('/admin/_app/platform-settings/terms-conditions')({
  component: TermsOfServicePage,
});
